/**
 * 国际化混入 (i18nMixin)
 * 用于在组件中便捷地使用国际化翻译
 */
export default {
  computed: {
    /**
     * 获取语言对象
     */
    $t() {
      return this.$store.state.live.languageObj || {};
    }
  },
  methods: {
    /**
     * 获取翻译文本
     * @param {String} key - 翻译的 key
     * @param {String} fallback - 如果没有找到翻译,返回的默认值
     * @returns {String} 翻译后的文本
     */
    $i18n(key, fallback = '') {
      const languageObj = this.$store.state.live.languageObj || {};
      return languageObj[key] || fallback || key;
    },

    /**
     * 检查翻译是否存在
     * @param {String} key - 翻译的 key
     * @returns {Boolean} 是否存在该翻译
     */
    $hasI18n(key) {
      const languageObj = this.$store.state.live.languageObj || {};
      return !!languageObj[key];
    }
  }
}
